/* eslint-disable class-methods-use-this */
import { AttachmentsApi, FoldersApi, ProjectApi } from 'SharedDir/backend/api';
import { AttachmentType, FileUploadOptions } from 'SharedDir/declarations/files';
import {
  DocumentInterface,
  FileSystemInterface,
  Folder,
  FolderCore,
} from 'SharedDir/declarations/filesystem';
import {
  ProjectFolder,
  TaskCommentDocumentBare,
  TaskCommentDocumentCore,
} from 'SharedDir/declarations/project-tasks';

export default class CommonFileSystem implements FileSystemInterface<Folder> {
  // eslint-disable-next-line class-methods-use-this
  uploadFile(file: FileList, options: FileUploadOptions) {
    return AttachmentsApi.uploadFile(file, options);
  }

  ls(parentId: Folder['id']) {
    return FoldersApi.get(parentId);
  }

  mkdir(data: FolderCore) {
    return FoldersApi.store(data);
  }

  mvdir(id, data) {
    return FoldersApi.update(id, data);
  }

  rmdir(id: ProjectFolder['id']) {
    return FoldersApi.delete(id);
  }

  // info(id: ProjectFolder['id']): Promise<ProjectFolder> {
  //   return ProjectApi.getFolder(this.projectId, id);
  // }

  // eslint-disable-next-line class-methods-use-this
  newdir(parentId: Folder['id']): FolderCore {
    return { name: 'Новая папка', parentId };
  }

  rmdoc(id: string) {
    return AttachmentsApi.removeFile(id);
  }

  // Ярлык: тот же blob, новая FileToFolder — не путать с upload/новым файлом.
  linkDoc(fileId: string, folderId: number) {
    return FoldersApi.linkFile(folderId, fileId);
  }

  // «Убрать из папки» ≠ DELETE /files/{uuid}; blob может жить в других папках.
  unlinkDoc(fileId: string, folderId: number) {
    return FoldersApi.unlinkFile(folderId, fileId);
  }

  moveDoc(fileId: string, sourceFolderId: number, targetFolderId: number) {
    return FoldersApi.moveFile(sourceFolderId, fileId, targetFolderId);
  }

  // mvdir = только rename (PUT name); смена родителя — отдельный endpoint.
  moveFolderTo(folderId: number, targetParentId: number, sourceParentId?: number) {
    return FoldersApi.moveFolder(folderId, targetParentId, sourceParentId);
  }

  copyFolder(folderId: number, targetParentId: number) {
    return FoldersApi.copyFolder(folderId, targetParentId);
  }
  // updatedoc(
  //   id: DocumentInterface['id'],
  //   data: TaskCommentDocumentCore
  // ): Promise<TaskCommentDocumentBare> {
  //   return ProjectApi.updateDocument(this.projectId, id.toString(), data);
  // }
}
